<template>
  <v-navigation-drawer
    class="width-menu z-999"
    fixed
    right
    temporary
    v-model="toggleMenu"
  >
    <div class="container-card d-flex align-center">
      <v-flex xs4 sm4 md4 lg4 xl4>
        <v-app-bar-nav-icon
          class="nav-font-55 text-icon-gary"
          @click="toggleMenu = false"
        />
      </v-flex>
      <v-flex xs8 sm8 md8 lg8 xl8 class="text-right">
        <img
          src="img/rsl/saleforec.png"
          width="140px"
          height="auto"
          @click="$router.push('/home')"
        />
      </v-flex>
    </div>

    <div class="container-card d-flex">
      <v-flex xs4 sm4 md4 lg4 xl4>
        <div>
          <v-avatar size="85">
            <v-img :src="user.profile"></v-img>
          </v-avatar>
        </div>
      </v-flex>
      <v-flex xs8 sm8 md8 lg8 xl8>
        <div>
          <span class="font-20 font-w-500 text-black">{{ user.name }}</span>
        </div>
        <div>
          <span class="font-16 text-red-d">{{ user.position }}</span>
        </div>
      </v-flex>
    </div>

    <div class="container-card">
      <v-divider></v-divider>
    </div>

    <div class="container-card">
      <v-flex xs12 sm12 md12 lg12 xl12>
        <button
          type="button"
          class="btn-manager"
          @click="linkToMenu('sales-order', true)"
        >
          <v-icon class="text-icon-w icon-font-35">icon-BASKET</v-icon>
          <span class="pl-2">เสนอราคา</span>
        </button>
      </v-flex>
    </div>

    <div class="container-card">
      <v-flex xs12 sm12 md12 lg12 xl12>
        <div class="my-5">
          <span class="font-20 text-black font-w-500 font-Prompt"
            >จัดการการขาย</span
          >
        </div>

        <div v-for="(item, index) in menu" :key="index">
          <div v-if="item.active">
            <div
              class="my-3 cursor-pointer"
              @click="linkToMenu(item.url, item.state)"
            >
              <v-icon v-if="item.iconMoon" style="font-size: 40px">{{
                item.iconMoon
              }}</v-icon>
              <img
                v-else
                :src="item.icon"
                class="icon-manager"
                style="object-fit: contain"
              />
              <span class="font-text-menu pl-2">{{ item.message }}</span>
            </div>
            <v-divider></v-divider>
          </div>
        </div>

        <div class="my-3 cursor-pointer" @click="submitLogout">
          <img
            src="img/icons_v2/icon-exit.png"
            class="icon-manager"
            style="margin-left: -2px"
          />
          <span class="font-text-menu pl-2">ออกจากระบบ</span>
        </div>
        <v-divider></v-divider>
      </v-flex>
    </div>

    <div class="version">ver 0.1.9build 95</div>
  </v-navigation-drawer>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import IconNote from '../../public/img/icons_v2/icon-note2.png'
import IconCustomerPlus from '../../public/img/icons_v2/icon-add-user@3x.png'
import IconLocation from '../../public/img/icons_v2/icon-main-location.png'
import IconSkutrans from '../../public/img/icons_v2/icon-mat-skutrans.png'
import IconHouse from '../../public/img/icons_v2/icon-house-store.png'
export default {
  data() {
    return {
      toggleMenu: false,
      menu: [
        {
          url: `quotations`,
          icon: IconCustomerPlus,
          message: 'ใบเสนอราคาทั้งหมด',
          active: true,
          state: 'prompt',
          iconMoon: 'icon-Billing3',
        },
        {
          url: 'stock',
          icon: IconSkutrans,
          message: 'เก็บราคา',
          active: true,
          state: 'local',
        },

        {
          url: 'calendar',
          icon: IconNote,
          message: 'ตารางเข้าเยี่ยม',
          active: true,
          state: 'local',
        },
        {
          url: 'listdata',
          icon: IconNote,
          message: 'บันทึกโน๊ต',
          active: true,
          state: 'local',
        },
        {
          url: 'checkinout',
          icon: IconLocation,
          message: 'เช็คอิน',
          active: true,
          state: 'local',
        },
        {
          url: `customer`,
          icon: 'img/icons/promotion.png',
          message: 'โปรโมชั่นรายเดือน',
          active: true,
          state: 'prompt',
        },
        {
          url: ``,
          icon: IconHouse,
          message: 'ร้านค้าทั้งหมด',
          active: false,
          state: 'prompt',
        },
        {
          url: `todo-list`,
          message: 'งานมอบหมาย',
          active: true,
          state: 'local',
          iconMoon: 'rd-file-down-dash font-red',
        },
        {
          url: `collect-target-price`,
          message: 'เก็บราคาตามเป้าหมาย',
          active: true,
          state: 'local',
          iconMoon: 'rd-product-coin font-red',
        },
      ],
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),

    ...mapGetters({
      newAccessToken: ['auth/getAccessToken'],
    }),
  },

  created() {
    this.setMenuPrompt()
  },

  methods: {
    submitLogout() {
      this.$store.dispatch('auth/getLogoutNew').then(() => {
        this.$router.push('/')
      })
    },

    linkToMenu(path, state) {
      const host = window.location.hostname
      const token = this.$store.getters['auth/getAuthToken']

      if (state == 'local') {
        this.$router.push(`/${path}`)
      } else {
        var refURL = ''
        var keyURL = `/rudy/signin?refToken=${token}&redirectUri=`

        if (path == 'customer') {
          refURL = `${keyURL}/bp-dummy/create`
        } else if (path == 'sales-order') {
          refURL = `${keyURL}/sales-order?qt=true`
        } else if (path == 'quotations') {
          refURL = `${keyURL}/quotations`
        }

        const checkURL =
          host == 'newpartner.scg.com'
            ? `${process.env.VUE_APP_URL_PROMPT_PROD}${refURL}`
            : `${process.env.VUE_APP_URL_PROMPT_TEST}${refURL}`

        window.open(checkURL)
      }
    },

    setMenuPrompt() {
      const host = window.location.hostname
      const token = this.$store.getters['auth/getAuthToken']
      const refCustomer = `?refToken=${token}&redirectUri=/bp-dummy/create`
      const linkCustomerDev = `${process.env.VUE_APP_URL_PROMPT_TEST}${refCustomer}`
      const linkCustomerProd = `${process.env.VUE_APP_URL_PROMPT_PROD}${refCustomer}`

      if (host == 'newpartner.scg.com') {
        this.menu[4].url = linkCustomerProd
      } else {
        this.menu[4].url = linkCustomerDev
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container-card {
  margin: 25px;
}
.btn-manager {
  // background-color: #c8c8c8;
  background-color: #fb8c00;
  color: white;
  width: 100%;
  height: 50px;
  border-radius: 8px;
}
.icon-manager {
  width: 40px;
  height: 40px;
}
.version {
  // position: absolute;
  // bottom: 0;
  // width: 100%;
  text-align: center;
  margin: 20px 0px;
  color: #c8c8c8;
  font-size: 18px;
  padding: 4px 0px;
}

.font-text-menu {
  font-size: 18px;
  color: #606060;
  font-weight: 400;
}
</style>
